import { Injectable  } from "@angular/core";

import { environment } from "environments/environment";
import KeyValuePair from "../models/key-value-pair.model";

@Injectable()
export class UtilService {

    // Site key do reCAPTCHA por ambiente (fileReplacements): dev/staging/prod.
    // Antes era por domínio, mas todos os ambientes rodam sob .oab.org.br — o
    // discriminador correto é o build (environment), não o hostname.
    getKeyRecaptcha(): string {
        return environment.recaptcha_site_key;
    }

    getArrayFromObject<T>(objList: Record<string, T>): T[] {
        const list: T[] = [];
        for (const prop in objList) {
            if (objList.hasOwnProperty(prop)) {
                list.push(objList[prop]);
            }
        }

        return list;
    }

    getDropdownSetoresSettings() {
        return {
            singleSelection: false,
            text: "Selecione os Setores",
            selectAllText: 'Marcar Todos',
            unSelectAllText: 'Desmacar Todos',
            enableFilterSelectAll: false,
            enableCheckAll: false,
            filterUnSelectAllText: 'Desmarcar todos os resultados pesquisados',
            enableSearchFilter: true,
            searchPlaceholderText: 'Pesquisar',
            filterSelectAllText: 'Marcar todos os resultados pesquisados',
            searchAutofocus: true,
            classes: "setorDrop",
            searchBy: ['itemName', 'itemNameSemAcc'],            
            noDataLabel: 'Nenhum item encontrado',
            badgeShowLimit: 1
        };
    }

    getEnquadramentos(): KeyValuePair[] {
        const enquadramentos = new Array<KeyValuePair>();        
        
        enquadramentos.push(({ key: '2', value: 'Comissão' } as KeyValuePair));        
        enquadramentos.push(({ key: '4', value: 'Funcional' } as KeyValuePair));       

        return enquadramentos;
    }

    isGuid(guid: string) : boolean {        
        const er = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        return er.test(guid);
    }

    removeAccents(str): string {
        const accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
        const accentsOut = "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
        str = str.split('');
        const strLen = str.length;
        let i, x;
        for (i = 0; i < strLen; i++) {
            if ((x = accents.indexOf(str[i])) != -1) {
                str[i] = accentsOut[x];
            }
        }

        return str.join('');
    }
}